import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const StockChangesPage = lazy(() => import('src/pages/stockChanges/stockChange'));
const CreateStockChangesPage = lazy(() => import('src/pages/stockChanges/createStockChange'));
const EditStockChangesPage = lazy(() => import('src/pages/stockChanges/editStockChange'));

export const stockChangesRoutes = [
  {
    path: 'stock-changes',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <StockChangesPage />, index: true },
      { path: 'new', element: <CreateStockChangesPage /> },
      { path: 'edit/:id', element: <EditStockChangesPage /> },
    ],
  },
];
